export default __webpack_public_path__ + "static/men-bodymap-face-2-b38ce8fcaae9f6d3c29ae9d9d489c20e.webp";